import { createReducer } from 'redux-create-reducer'
import type { TourEvent } from 'types/tour-event'
import { EVENT_SEND, PRELOAD_DATA_ON_LOGIN } from '@disco/constants/ActionTypes'
const initialState = {
  events: [],
  tourEventsLoaded: false,
}
export type State = {
  events: TourEvent[]
  tourEventsLoaded: boolean
}
export const eventsReducer = createReducer<State, any>(initialState, {
  [PRELOAD_DATA_ON_LOGIN](state, action) {
    if (action.entities.tourEvents) {
      return {
        ...state,
        events: [...state.events, ...action.entities.tourEvents],
        tourEventsLoaded: true,
      }
    }

    return state
  },

  [EVENT_SEND](state, action) {
    return { ...state, events: [...state.events, action.event] }
  },
}) as (state: State, action: any) => State
